import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  @Input() component: any;
  @Input() formDesign: any;
  @Output() onChangeEmitter: any = new EventEmitter();
  @Input() formState: any;

  myState: any = false;
  
  constructor() {}

  ngOnInit() {
    if(this.formState) {
      this.myState = this.formState[this.component.element.field_name]
    }
  }

  ngOnChanges(c: any) {
    if(this.formState) {
      this.myState = this.formState[this.component.element.field_name]
    }
  }

  onChange(e: any) {
    this.onChangeEmitter.emit({ 
      component: this.component, 
      eventType: "valueChange",
      value: e.target.checked })
  }
}
